import { createReducer } from '@reduxjs/toolkit';

import * as queryPanelActionTypes from './queryPanel.actions';
import { QueryPanelState } from './models';

const INITIAL_STATE: QueryPanelState = {
  subjectGradeInfo: null,
  subjectGradeTemplate: null,
  isTemplateCached: false,
  itemCount: 0,
  itemCountLoaded: false,
  itemCountLoading: false,
  loading: false,
  loaded: false,
  errMsg: null
};

const queryPanelReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(queryPanelActionTypes.loadAllSGInfoStart, (state) => {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    })
    .addCase(queryPanelActionTypes.loadAllSGInfoSuccess, (state, action) => {
      return {
        ...state,
        subjectGradeInfo: null,
        subjectGradeTemplate: action.payload,
        isTemplateCached: true,
        loading: false,
        loaded: false,
      };
    })
    .addCase(queryPanelActionTypes.loadAllSGInfoFailure, (state, action) => {
      return {
        ...state,
        subjectGradeInfo: null,
        subjectGradeTemplate: null,
        isTemplateCached: false,
        loading: false,
        loaded: false,
        errMsg: action.payload
      };
    })
    .addCase(queryPanelActionTypes.loadSGInfoStart, (state) => {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    })
    .addCase(queryPanelActionTypes.loadSGInfoSuccess, (state, action) => {
      return {
        ...state,
        subjectGradeInfo: action.payload,
        loading: false,
        loaded: true,
      };
    })
    .addCase(queryPanelActionTypes.loadSGInfoFailure, (state, action) => {
      return {
        ...state,
        loading: false,
        loaded: false,
        errMsg: action.payload
      };
    })
    .addCase(queryPanelActionTypes.resetSGInfo, (state) => {
      return {
        ...state,
        subjectGradeInfo: state.subjectGradeTemplate,
        itemCount: 0,
        loading: false,
        loaded: false,
        itemCountLoaded: false,
        itemCountLoading: false,
      };
    })
    .addCase(queryPanelActionTypes.loadItemCountStart, (state) => {
      return {
        ...state,
        itemCountLoading: true,
        itemCountLoaded: false,
      };
    })
    .addCase(queryPanelActionTypes.loadItemCountSuccess, (state, action) => {
      return {
        ...state,
        itemCount: action.payload.itemCount,
        itemCountLoading: false,
        itemCountLoaded: true,
      };
    })
    .addCase(queryPanelActionTypes.loadItemCountFailure, (state, action) => {
      return {
        ...state,
        itemCount: 0,
        itemCountLoading: false,
        itemCountLoaded: false,
        errMsg: action.payload
      };
    })
    .addCase(queryPanelActionTypes.resetItemCount, (state) => {
      return {
        ...state,
        itemCount: 0,
        itemCountLoading: false,
        itemCountLoaded: false,
      };
    });
});

export default queryPanelReducer;